import Blue from "~/core";

new Blue({
	name: 'Header Nav Menu',
  selector: ".headerMain",
  setup(header) {
		const newInner = header.querySelector(".headerMain__inner") || false;
		if (newInner) {
			const menuInner = header.querySelector(".headerMain__menu");
			const trigger = header.querySelector(".headerMain__menuToggle");
			const close = header.querySelector(".headerMain__menuClose, .headerMain-menuClose");
			let vh;
			const setHeight = () => {
				if (window.innerWidth <= 1080) {
					vh = window.innerHeight * 0.01;
					document.documentElement.style.setProperty('--vh', `${vh}px`);
					menuInner.style.height = `calc(var(--vh, 1vh) * 100)`;
				}
			}
			this.$addEvents(trigger, 'click', function(e){
				e.preventDefault();
				e.stopPropagation();
				document.body.classList.add('disableScroll');
				document.body.classList.add('is-mainMenuOpen');
        trigger.setAttribute('aria-expanded', 'true');
			});
			this.$addEvents(close, 'click', function(e){
				e.preventDefault();
				e.stopPropagation();
				document.body.classList.remove('disableScroll');
				document.body.classList.remove('is-mainMenuOpen');
        trigger.setAttribute('aria-expanded', 'false');
			});
			this.$retach(close, {
				destination: '.headerMain__menuSearchTitle',
				mediaQuery: 1080,
				callback_move() {
					setHeight()
				},
				callback_back() {
					menuInner.style.height = ''
				}
			});
		}
  }
});
